import axios from 'axios';
import { SWAP_EXERCISE_LIST } from '../../constants';

export const fetchSwapExerciseList = (exID, onError) => (dispatch) => {
  dispatch(loadSwapExerciseList());

  axios
    .get(`/program/listSwapExercise?exerciseId=${exID}`)
    .then((res) => dispatch(setSwapExerciseList(res.data.data)))
    .catch((err) => {
      dispatch(errorSwapExerciseList(err.response));
      onError(err.response);
    });
};

export const loadSwapExerciseList = () => ({
  type: SWAP_EXERCISE_LIST.LOAD
});

export const setSwapExerciseList = (exerciseList) => ({
  type: SWAP_EXERCISE_LIST.SUCCESS,
  payload: exerciseList
});

export const errorSwapExerciseList = (error) => ({
  type: SWAP_EXERCISE_LIST.FAIL,
  payload: error
});
